import { Produto } from "@/types/produto";
import { TipoCultura } from "@/types/tipoCultura";
import { TipoUsuario } from "@/utils/enums/tipoUsuario";
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "..";


export type SiteState = {
    step: number;
    tipoUsuario: string;
    culturas: TipoCultura[];
    estado: string;
    cidade: string;
    tamanho: string;
    modalTermos: boolean;
    produto?: Produto;
}


const initialState: SiteState = {
    step: 0,
    tipoUsuario: TipoUsuario.VISITANTE,
    culturas: [],
    estado: '',
    cidade: '',
    tamanho: '',
    modalTermos: true,
}


export const siteSlice = createSlice({
    name: 'site',
    initialState,
    reducers: {
        setStep: (state, action) => {
            state.step = action.payload;
        },
        setEstado: (state, action) => {
            state.estado = action.payload;
        },
        setCidade: (state, action) => {
            state.cidade = action.payload;
        },
        setModalTermos: (state, action) => {
            state.modalTermos = action.payload;
        },
        setProduto: (state, action) => {
            state.produto = action.payload;
        }
    },

})


export default siteSlice.reducer

export const useSiteActions = siteSlice.actions;

export const useSiteState = (state: RootState) => state.site;